export const FETCH_RESEARCHERS_PAGE = '@@researchers/FETCH_RESEARCHERS_PAGE';
export const FETCH_RESEARCHERS_PAGE_SUCCESS = '@@researchers/FETCH_RESEARCHERS_PAGE_SUCCESS';
export const FETCH_RESEARCHERS_PAGE_ERROR = '@@researchers/FETCH_RESEARCHERS_PAGE_ERROR';

export const SET_SELECTED_THEME_SLUG = '@@researchers/SET_SELECTED_THEME_SLUG';
export const SET_SELECTED_TAB_INDEX = '@@researchers/SET_SELECTED_TAB_INDEX';
export const SET_RESEARCHER_TABS = '@@researchers/SET_RESEARCHER_TABS';

export const FETCH_RESEARCHER = '@@researchers/FETCH_RESEARCHER';
export const FETCH_RESEARCHER_SUCCESS = '@@researchers/FETCH_RESEARCHER_SUCCESS';
export const FETCH_RESEARCHER_ERROR = '@@researchers/FETCH_RESEARCHER_ERROR';
